import React, { useEffect, useState } from 'react'
import styles from './add.module.scss'
import { filterOptionSelect, generatorTreeNodeCategories, removeAccents } from 'utils'
import moment from 'moment-timezone'
import { useHistory, useLocation } from 'react-router-dom'
import { ACTION, IMAGE_DEFAULT, ROUTES } from 'consts'
import { useDispatch } from 'react-redux'

import {
  Select,
  Row,
  Col,
  notification,
  Button,
  Input,
  Form,
  InputNumber,
  Checkbox,
  DatePicker,
  Upload,
  Table,
  Space,
  TreeSelect,
  Tag,
  Spin,
} from 'antd'
import { ArrowLeftOutlined, CheckOutlined, PlusOutlined } from '@ant-design/icons'

//components
import TitlePage from 'components/title-page'

//apis
import { addPromotion, updatePromotion, getPromotions } from 'apis/promotion'
import { getBranches } from 'apis/branch'
import { getRegions } from 'apis/region'
import { getCountries } from 'apis/country'
import { getProducts } from 'apis/product'
import { uploadFile } from 'apis/upload'
import { getCategories } from 'apis/category'

const time_range = [
  { name: '00:00' },
  { name: '00:30' },
  { name: '01:00' },
  { name: '01:30' },
  { name: '02:00' },
  { name: '02:30' },
  { name: '03:00' },
  { name: '03:30' },
  { name: '04:00' },
  { name: '04:30' },
  { name: '05:00' },
  { name: '05:30' },
  { name: '06:00' },
  { name: '06:30' },
  { name: '07:00' },
  { name: '07:30' },
  { name: '08:00' },
  { name: '08:30' },
  { name: '09:00' },
  { name: '09:30' },
  { name: '10:00' },
  { name: '10:30' },
  { name: '11:00' },
  { name: '11:30' },
  { name: '12:00' },
  { name: '12:30' },
  { name: '13:00' },
  { name: '13:30' },
  { name: '14:00' },
  { name: '14:30' },
  { name: '15:00' },
  { name: '15:30' },
  { name: '16:00' },
  { name: '16:30' },
  { name: '17:00' },
  { name: '17:30' },
  { name: '18:00' },
  { name: '18:30' },
  { name: '19:00' },
  { name: '19:30' },
  { name: '20:00' },
  { name: '20:30' },
  { name: '21:00' },
  { name: '21:30' },
  { name: '22:00' },
  { name: '22:30' },
  { name: '23:00' },
  { name: '23:30' },
]
const time_date_of_week = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
]
const { Option } = Select
export default function PromotionForm() {
  const [form] = Form.useForm()
  const history = useHistory()
  const location = useLocation()
  const dispatch = useDispatch()
  const query = new URLSearchParams(location.search)

  const [paramsFilter, setParamsFilter] = useState({})
  const [categories, setCategories] = useState([])
  const [promotion, setPromotion] = useState(null)
  const [branches, setBranches] = useState([])
  const [regions, setRegions] = useState([])
  const [countries, setCountries] = useState([])
  const [products, setProducts] = useState([])
  const [productsId, setProductsId] = useState([])
  const [showVoucher, setShowVoucher] = useState('show')
  const [isApplyProduct, setIsApplyProduct] = useState(false)
  const [loading, setLoading] = useState(false)
  const [loadingTable, setLoadingTable] = useState(false)
  const [imagePromotion, setImagePromotion] = useState('')

  const [indexHourStart, setIndexHourStart] = useState(0)
  const [indexHourEnd, setIndexHourEnd] = useState(0)

  const onFinish = async () => {
    await form.validateFields()
    const formData = form.getFieldsValue()

    const timeStartDate = new Date(formData.start_date).getTime()
    const timeEndDate = new Date(formData.end_date).getTime()
    const stringStartDate = moment(new Date(formData.start_date)).format('YYYY-MM-DD')
    const stringEndDate = moment(new Date(formData.end_date)).format('YYYY-MM-DD')
    if (timeStartDate > timeEndDate) {
      notification.warning({ message: 'Ngày kết thúc phải lớn hơn hoặc bằng   ngày bắt đầu' })
      return
    }

    try {
      await form.validateFields()

      const body = {
        ...formData,
        image_urls: imagePromotion ? [imagePromotion] : [],
        start_date: moment(stringStartDate).tz('Asia/Ho_Chi_Minh').format('YYYY-MM-DD'),
        end_date: moment(stringEndDate).tz('Asia/Ho_Chi_Minh').format('YYYY-MM-DD'),
        end_hour: formData.end_hour,
        start_hour: formData.start_hour,
        has_voucher: showVoucher === 'show',
        limit: {
          amount: formData.amount ? parseInt(formData.amount) : 0,
          stores: formData.store ? formData.store : [],
        },
        description: formData.description || '',
        is_apply_all_product: productsId.length > 0 ? true : false,
        apply_product_ids: productsId || [],
      }
      // if (indexHourEnd < indexHourStart) {
      //  notification.warning({ message: 'Vui lòng chọn giờ kết thúc lớn hơn giờ bắt đầu' })
      //   return
      // }

      console.log(body)

      setLoading(true)
      let res
      if (promotion) res = await updatePromotion(promotion.promotion_id, body)
      else res = await addPromotion(body)
      console.log(res)
      setLoading(false)

      if (res.status === 200) {
        if (res.data.success) {
          history.push(ROUTES.PROMOTION)
          notification.success({
            message: `${promotion ? 'Cập nhật' : 'Thêm'} chương trình khuyến mãi thành công`,
          })
        } else
          notification.error({
            message:
              res.data.message ||
              `${
                promotion ? 'Cập nhật' : 'Thêm'
              } chương trình khuyến mãi thất bại, vui lòng thử lại`,
          })
      } else
        notification.error({
          message:
            res.data.message ||
            `${promotion ? 'Cập nhật' : 'Thêm'} chương trình khuyến mãi thất bại, vui lòng thử lại`,
        })
    } catch (e) {
      console.log(e)
      setLoading(false)
    }
  }

  const columnsProduct = [
    { width: 80, title: 'STT', render: (text, record, index) => index + 1 },
    { title: 'Tên món ăn', dataIndex: 'name' },
    { title: 'Mã', dataIndex: 'sku', render: (text, record) => record.sku },
    {
      title: 'Phân loại món',
      render: (text, record) =>
        record.category_info && (
          <Space wrap={true}>
            {record.category_info.map((category, index) => (
              <Tag key={index} closable={false}>
                {category.name}
              </Tag>
            ))}
          </Space>
        ),
    },

    {
      width: 100,
      title: 'Hình ảnh',
      render: (text, record) =>
        record.image_urls && (
          <img
            style={{ width: 60, height: 60 }}
            src={(record.image_urls.length && record.image_urls[0]) || IMAGE_DEFAULT}
            alt=""
          />
        ),
    },
    {
      title: 'Áp dụng món ăn vào CTKM',
      render: (text, record) => {
        const isHave = productsId.find((id) => id === record.product_id)
        if (!isHave) {
          console.log(productsId.length)
        }
        return (
          <Checkbox
            checked={isHave}
            onChange={(e) => {
              const productsIdNew = [...productsId]
              if (e.target.checked) productsIdNew.push(record.product_id)
              else {
                const indexId = productsIdNew.findIndex((id) => id === record.product_id)
                if (indexId !== -1) productsIdNew.splice(indexId, 1)
              }
              setProductsId([...productsIdNew])
            }}
          >
            {isHave ? 'Đã thêm' : 'Chưa thêm'}
          </Checkbox>
        )
      },
    },
  ]

  useEffect(() => {
    console.log(products.length)
  }, [products])

  const _getCategories = async () => {
    try {
      const res = await getCategories({ parent: true })
      if (res.status === 200) {
        if (res.data.data && res.data.data.length) {
          setCategories(res.data.data.map((e) => generatorTreeNodeCategories(e)))
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  const generateCode = (value) => {
    let tmp = value.toUpperCase()
    tmp = tmp.replace(/\s/g, '')
    tmp = removeAccents(tmp)
    return tmp
  }

  const _getBranches = async (query = {}) => {
    try {
      const res = await getBranches(query)
      if (res.status === 200) setBranches(res.data.data)
    } catch (e) {
      console.log(e)
    }
  }

  const _getCountries = async () => {
    try {
      const res = await getCountries()
      if (res.status === 200) setCountries(res.data.data)
    } catch (e) {
      console.log(e)
    }
  }

  const _getRegions = async (query = {}) => {
    try {
      const res = await getRegions(query)
      if (res.status === 200) setRegions(res.data.data)
    } catch (e) {
      console.log(e)
    }
  }

  const _getProducts = async () => {
    try {
      setLoading(true)
      const res = await getProducts({
        ...paramsFilter,
        page_size: 99999,
        page: 1,
        is_souvenir: false,
      })
      if (res.status === 200)
        setProducts(res.data.data.filter((item) => item.is_souvenir === false))
      setLoading(false)
    } catch (e) {
      console.log(e)
      setLoading(false)
    }
  }

  useEffect(() => {
    _getProducts()
  }, [paramsFilter])

  const getProductPromotion = async () => {
    try {
      setLoadingTable(true)
      const promotionId = query.get('id')
      if (promotionId) {
        const resProduct = await getProducts({
          promotion_id: promotionId,
          page_size: 1000,
          page: 1,
        })
        var _productIds = []

        resProduct.data.data.map((product) => {
          _productIds.push(product.product_id)
        })
        setProductsId(_productIds || [])
      }

      setLoadingTable(false)
    } catch (err) {
      setLoadingTable(false)
    }
  }

  const _getPromotion = async (id) => {
    try {
      getProductPromotion()
      dispatch({ type: ACTION.LOADING, data: true })
      const res = await getPromotions({ promotion_id: id })
      if (res.status === 200) {
        const promotionObj = res.data.data && res.data.data.length && res.data.data[0]
        if (promotionObj) {
          setPromotion(promotionObj)
          form.setFieldsValue({
            ...promotionObj,
            start_date: moment(promotionObj.start_date),
            end_date: moment(promotionObj.end_date),
            start_hour: promotionObj.start_hour,
            end_hour: promotionObj.end_hour,
          })
          setImagePromotion(
            (promotionObj.image_urls &&
              promotionObj.image_urls.length &&
              promotionObj.image_urls[0]) ||
              ''
          )
        } else {
          history.push(ROUTES.PROMOTION)
          notification.error({ message: 'Không tìm thấy chương trình khuyến mãi này' })
        }
      }
      dispatch({ type: ACTION.LOADING, data: false })
    } catch (error) {
      dispatch({ type: ACTION.LOADING, data: false })
      console.log(error)
    }
  }

  useEffect(() => {
    if (indexHourStart && indexHourEnd)
      if (indexHourEnd < indexHourStart)
        notification.warning({ message: 'Vui lòng chọn giờ kết thúc lớn hơn giờ bắt đầu' })
  }, [indexHourStart, indexHourEnd])

  useEffect(() => {
    _getCountries()
    _getRegions()
    //_getBranches()
    _getCategories()
    _getProducts()
  }, [])

  useEffect(() => {
    const promotionId = query.get('id')
    if (promotionId) _getPromotion(promotionId)
  }, [])

  return (
    <>
      <div className={`${styles['promotion_manager']} ${styles['card']}`}>
        <TitlePage
          title={
            <Row
              align="middle"
              onClick={() => history.push(ROUTES.PROMOTION)}
              style={{ cursor: 'pointer', width: 'max-content' }}
            >
              <ArrowLeftOutlined style={{ fontSize: 18 }} />
              <div style={{ marginBottom: 0, marginLeft: 7 }}>
                {promotion ? (
                  <div>
                    Cập nhật chương trình khuyến mãi{' '}
                    <b style={{ fontSize: 20 }}>{promotion.name}</b>
                  </div>
                ) : (
                  'Tạo chương trình khuyến mãi'
                )}
              </div>
            </Row>
          }
        >
          <div className={styles['promotion_add_button']}>
            <Button
              onClick={onFinish}
              loading={loading}
              size="large"
              type="primary"
              style={{ width: 120 }}
            >
              {promotion ? 'Cập nhật' : 'Thêm'}
            </Button>
          </div>
        </TitlePage>

        <div>
          <Form form={form} layout="vertical">
            <Row gutter={30}>
              <Col span={24}>
                <div className={styles['promotion-add__box']}>
                  <Row wrap={false} justify="space-between">
                    <Upload
                      listType="picture-card"
                      className="upload-category-image"
                      showUploadList={false}
                      data={async (file) => {
                        try {
                          const url = await uploadFile(file)
                          if (url) setImagePromotion(url)
                        } catch (error) {}
                      }}
                    >
                      {imagePromotion ? (
                        <img src={imagePromotion} alt="avatar" style={{ width: '100%' }} />
                      ) : (
                        <div>
                          <PlusOutlined />
                          <div style={{ marginTop: 8 }}>Tải lên</div>
                        </div>
                      )}
                    </Upload>
                  </Row>
                  <Row wrap={false} justify="space-between">
                    <Form.Item
                      rules={[{ message: 'Vui lòng nhập tên khuyến mãi', required: true }]}
                      name="name"
                      label="Tên khuyến mãi"
                      style={{ width: '30%' }}
                    >
                      <Input
                        placeholder="Nhập tên khuyến mãi"
                        size="large"
                        onChange={(e) => {
                          form.setFieldsValue({
                            promotion_code: generateCode(e.target.value),
                          })
                        }}
                      />
                    </Form.Item>

                    <Form.Item
                      rules={[{ message: 'Vui lòng nhập mô tả ngắn', required: true }]}
                      name="short_description"
                      label="Mô tả ngắn"
                      style={{ width: '30%' }}
                    >
                      <Input placeholder="Nhập mô tả ngắn" size="large" />
                    </Form.Item>

                    <Form.Item
                      rules={[{ message: 'Vui lòng nhập mã khuyến mãi', required: true }]}
                      name="promotion_code"
                      label="Mã khuyến mãi"
                      style={{ width: '30%' }}
                    >
                      <Input placeholder="Nhập mã khuyến mãi" size="large" />
                    </Form.Item>
                  </Row>
                  <Row wrap={false} justify="space-between">
                    <Form.Item
                      rules={[{ message: 'Vui lòng chọn ngày bắt đầu', required: true }]}
                      style={{ width: '48%' }}
                      name="start_date"
                      label="Ngày bắt đầu"
                    >
                      <DatePicker
                        placeholder="Chọn ngày bắt đầu"
                        size="large"
                        style={{ width: '100%' }}
                      />
                    </Form.Item>
                    <Form.Item
                      rules={[{ message: 'Vui lòng chọn ngày kết thúc', required: true }]}
                      style={{ width: '48%' }}
                      name="end_date"
                      label="Ngày kết thúc"
                    >
                      <DatePicker
                        placeholder="Chọn ngày kết thúc"
                        size="large"
                        style={{ width: '100%' }}
                      />
                    </Form.Item>
                  </Row>
                  <Row wrap={false} justify="space-between">
                    <Form.Item
                      rules={[{ message: 'Vui lòng chọn giờ bắt đầu', required: true }]}
                      style={{ width: '48%' }}
                      name="start_hour"
                      label="Giờ bắt đầu"
                    >
                      <Select
                        onChange={(e) => {
                          var index = time_range.findIndex((time) => time.name == e)
                          setIndexHourStart(index)
                        }}
                        placeholder="Chọn giờ bắt đầu"
                        size="large"
                      >
                        {time_range.map((_time, index) => {
                          return <Option value={_time.name}>{_time.name}</Option>
                        })}
                      </Select>
                    </Form.Item>
                    <Form.Item
                      rules={[{ message: 'Vui lòng chọn giờ kết thúc', required: true }]}
                      style={{ width: '48%' }}
                      name="end_hour"
                      label="Giờ kết thúc"
                    >
                      <Select
                        onChange={(e) => {
                          var index = time_range.findIndex((time) => time.name == e)
                          setIndexHourEnd(index)
                        }}
                        placeholder="Chọn giờ kết thúc"
                        size="large"
                      >
                        {time_range.map((_time, index) => {
                          return <Option value={_time.name}>{_time.name}</Option>
                        })}
                      </Select>
                    </Form.Item>
                  </Row>

                  <Row wrap={false} justify="space-between">
                    <Form.Item
                      style={{ width: '48%' }}
                      name="is_apply_all_days"
                      label="Áp dụng tất cả ngày trong tuần"
                      valuePropName="checked"
                    >
                      <Checkbox />
                    </Form.Item>
                    <Form.Item
                      style={{ width: '48%' }}
                      name="apply_days"
                      label="Chọn thời điểm áp dụng (trong tuần)"
                    >
                      <Select
                        mode="multiple"
                        // onChange={(e) => {
                        //   var index = time_range.findIndex((time) => time.name == e)
                        //   setIndexHourEnd(index)
                        // }}
                        placeholder="Chọn thứ trong tuần"
                        size="large"
                        allowClear
                      >
                        {time_date_of_week.map((_time) => {
                          return <Option value={_time}>{_time}</Option>
                        })}
                      </Select>
                    </Form.Item>
                  </Row>

                  <Row wrap={false} justify="space-between">
                    <Form.Item
                      style={{ width: '48%' }}
                      name="total_promotion"
                      label="Số lượng khuyến mãi"
                      // rules={[{ message: 'Vui lòng nhập số lượng khuyến mãi', required: true }]}
                    >
                      <Input
                        placeholder="Nhập số lượng khuyến mãi"
                        size="large"
                        style={{ width: '100%', borderRadius: '15px' }}
                      />
                    </Form.Item>

                    <Form.Item
                      style={{ width: '48%' }}
                      name="value"
                      label="Giá trị khuyến mãi"
                      //  rules={[{ message: 'Vui lòng nhập giá trị khuyến mãi', required: true }]}
                    >
                      <InputNumber
                        min={0}
                        placeholder="Nhập giá trị khuyến mãi"
                        size="large"
                        style={{ width: '100%', borderRadius: '15px' }}
                        formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                      />
                    </Form.Item>
                  </Row>

                  <Row wrap={false} justify="space-between">
                    <Form.Item
                      style={{ width: '48%' }}
                      name="type"
                      initialValue="value"
                      label="Loại khuyến mãi"
                    >
                      <Select placeholder="Loại khuyến mãi" size="large">
                        <Option value="value">Giá trị</Option>
                        <Option value="percent">Phần trăm</Option>
                      </Select>
                    </Form.Item>
                    <Form.Item
                      rules={[{ message: 'Vui lòng chọn quốc gia', required: true }]}
                      style={{ width: '48%' }}
                      name="country_ids"
                      label="Quốc gia"
                    >
                      <Select
                        mode="multiple"
                        filterOption={filterOptionSelect}
                        optionFilterProp="children"
                        showSearch
                        size="large"
                        placeholder="Chọn quốc gia"
                      >
                        {countries.map((country, index) => (
                          <Select.Option key={index} value={country.country_id}>
                            {country.name}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Row>

                  <Row wrap={false} justify="space-between">
                    <Form.Item
                      rules={[{ message: 'Vui lòng chọn khu vực', required: true }]}
                      style={{ width: '48%' }}
                      name="region_ids"
                      label="Khu vực"
                    >
                      <Select
                        mode="multiple"
                        filterOption={filterOptionSelect}
                        optionFilterProp="children"
                        showSearch
                        size="large"
                        placeholder="Chọn khu vực"
                      >
                        {regions.map((region, index) => (
                          <Select.Option key={index} value={region.region_id}>
                            {region.name}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>

                    {/* <Form.Item
                    rules={[{ message: 'Vui lòng chọn chi nhánh', required: true }]}
                    style={{ width: '48%' }}
                    name="branch_ids"
                    label="Chi nhánh"
                  >
                    <Select
                      allowClear
                      mode="multiple"
                      filterOption={filterOptionSelect}
                      optionFilterProp="children"
                      showSearch
                      size="large"
                      placeholder="Chọn chi nhánh"
                    >
                      {branches.map((branch) => (
                        <Select.Option key={branch.branch_id} value={branch.branch_id}>
                          {branch.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item> */}
                  </Row>

                  <Row>
                    <Form.Item style={{ width: '48%' }} name="description" label="Mô tả">
                      <Input.TextArea rows={3} placeholder="Nhập mô tả" />
                    </Form.Item>
                  </Row>

                  {/* <Row wrap={false} justify="space-between">
                  <Checkbox
                    checked={isApplyProduct}
                    onChange={(e) => {
                      setIsApplyProduct(e.target.checked)
                    }}
                  >
                    Áp dụng vào tất cả món ăn
                  </Checkbox>
                </Row> */}
                  {loading && (
                    <div
                      style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                    >
                      <Spin size={100} />
                    </div>
                  )}
                  <br />
                  {
                    !loading && (
                      <div>
                        <Row align="middle" justify="space-between" style={{ marginBottom: 10 }}>
                          <Space>
                            <div>
                              <div>
                                <div>Lọc món ăn theo khu vực</div>
                                <Select
                                  allowClear
                                  filterOption={filterOptionSelect}
                                  optionFilterProp="children"
                                  showSearch
                                  size="large"
                                  placeholder="Chọn khu vực"
                                  onChange={(value) => {
                                    setParamsFilter({ ...paramsFilter, region_id: value })
                                  }}
                                  value={paramsFilter.region_id}
                                  style={{ width: 350 }}
                                >
                                  {regions.map((region) => (
                                    <Select.Option key={region.region_id} value={region.region_id}>
                                      {region.name}
                                    </Select.Option>
                                  ))}
                                </Select>
                              </div>

                              <div>Lọc món ăn theo chi nhánh</div>
                              <Select
                                allowClear
                                filterOption={filterOptionSelect}
                                optionFilterProp="children"
                                showSearch
                                size="large"
                                placeholder="Chọn chi nhánh"
                                onChange={(value) => {
                                  setParamsFilter({ ...paramsFilter, branch_id: value })
                                }}
                                value={paramsFilter.branch_id}
                                style={{ width: 350 }}
                              >
                                {branches.map((branch) => (
                                  <Select.Option key={branch.branch_id} value={branch.branch_id}>
                                    {branch.name}
                                  </Select.Option>
                                ))}
                              </Select>
                            </div>
                            <div>
                              <div>Lọc món ăn theo nhóm</div>
                              <TreeSelect
                                showCheckedStrategy={TreeSelect.SHOW_ALL}
                                size="large"
                                style={{ width: 350 }}
                                treeNodeFilterProp="title"
                                maxTagCount="responsive"
                                placeholder="Chọn phân loại món"
                                allowClear
                                multiple
                                treeDefaultExpandAll
                                treeData={categories}
                                onChange={(value) =>
                                  setParamsFilter({
                                    ...paramsFilter,
                                    category_id: value.join('---'),
                                  })
                                }
                                value={
                                  paramsFilter.category_id
                                    ? paramsFilter.category_id.split('---').map((e) => +e)
                                    : []
                                }
                              />
                            </div>
                          </Space>

                          <b>
                            <Button
                              type="primary"
                              onClick={(e) => {
                                setProductsId([])
                              }}
                            >
                              Bỏ chọn tất cả SP
                            </Button>
                          </b>

                          <b>
                            <Checkbox
                              onChange={(e) => {
                                if (e.target.checked) {
                                  var _listId = [...productsId]
                                  var _products = []
                                  products.map((_p) => {
                                    _products.push(_p.product_id)
                                  })
                                  _listId.map((_id) => {
                                    _products.push(_id)
                                  })
                                  setProductsId(_products)
                                }
                              }}
                            >
                              Áp dụng theo bộ lọc
                            </Checkbox>
                          </b>
                        </Row>
                        <div>{'Đã chọn: ' + productsId.length}</div>
                        <div>{'Tổng SP bên dưới: ' + products.length}</div>
                        <Table
                          scroll={{ y: '60vh' }}
                          loading={loadingTable}
                          columns={columnsProduct}
                          pagination={false}
                          dataSource={products}
                          size="small"
                        />
                      </div>
                    )
                    // <Form.Item label="Danh sách món ăn" name="apply_product_ids">
                    //   <Select
                    //     size="large"
                    //     allowClear
                    //     mode="multiple"
                    //     placeholder="Chọn món ăn"
                    //     showSearch
                    //     optionFilterProp="children"
                    //     dropdownRender={(menu) => (
                    //       <>
                    //         {menu}
                    //         <Checkbox
                    //           style={{ marginLeft: 10 }}
                    //           onChange={(e) => {
                    //             if (e.target.checked)
                    //               form.setFieldsValue({
                    //                 apply_product_ids: products.map((product) => product.product_id),
                    //               })
                    //             else form.setFieldsValue({ apply_product_ids: [] })
                    //           }}
                    //         >
                    //           Chọn tất cả
                    //         </Checkbox>
                    //       </>
                    //     )}
                    //   >
                    //     {products.map((product, index) => (
                    //       <Select.Option key={index} value={product.product_id}>
                    //         {product.name}
                    //       </Select.Option>
                    //     ))}
                    //   </Select>
                    // </Form.Item>
                  }
                </div>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    </>
  )
}
